export default "fn sdfSphere(\n    pos: vec3<f32>,\n    c: vec3<f32>,\n    r: f32\n) -> f32 {\n    return length(pos- c) - r;\n}\n";